/**
 * Application configuration derived from Vite environment variables.
 *
 * `apiBaseUrl` resolves to:
 *   - `VITE_API_BASE_URL` when set (e.g. an absolute API origin), otherwise
 *   - same-origin `/api` (the dev server proxies `/api` → http://localhost:8000,
 *     and the demo deployment serves the API under `/api` behind Caddy).
 */

const envBase = import.meta.env.VITE_API_BASE_URL as string | undefined;

/** Token storage key in localStorage (shared by api client + AuthContext). */
export const AUTH_TOKEN_KEY = 'tridsys_auth_token';

export const config = {
  /** Base URL prefix for all API calls. Defaults to same-origin `/api`. */
  apiBaseUrl: envBase && envBase.length > 0 ? envBase.replace(/\/$/, '') : '/api',
  /** Whether the backend is running in mock mode (surfaced for UI banners). */
  mockMode: (import.meta.env.VITE_MOCK_MODE as string | undefined) !== 'false',
} as const;

export type AppConfig = typeof config;
